import ClientAnalyticsChart from './ClientAnalyticsChart';

export default ClientAnalyticsChart;
